export const enum EventTypes {
    CLICK = "click",
    MOUSE_MOVE = "mousemove",
    MOUSE_OVER = "mouseover",
    MOUSE_DOWN = "mousedown",
    MOUSE_UP = "mouseup",
    MOUSE_OUT = "mouseout",
    KEY_PRESS = "keypress",
    KEY_DOWN = "keydown",
    KEY_UP = "keyup",
    DOM_FOCUS_IN = "DOMFocusIn",
    DOM_FOCUS_OUT = "DOMFocusOut",
    DOM_ACTIVATE = "DOMActivate",
    SELECT = "select",
    CHANGE = "change",
    SUBMIT = "submit",
    RESET = "reset",
    FOCUS = "focus",
    BLUR = "blur",
    LOAD = "load",
    SCROLL = "scroll",
    RESIZE = "resize",
}
